import { find, get, isArray } from 'lodash-es';

import { getMainConfig } from './config';

export * from './config';
export * from './helpers';
export * from './baseTitle';
export * from './offlineAdapter';
export * from './modules';
export * from './services';
export { default as logger } from './logger';

export const getDisplayName = (profile) => {
  const configProps = getMainConfig('displayUserName') ?? ['preferred_username'];
  const preferredProperties = isArray(configProps) ? configProps : [configProps];
  return get(profile, find(preferredProperties, (key) => profile[key]) as string, 'N/A');
};
